import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAsync, postAsync } from "src/api/Api";
import { store } from "src/redux/store";
import { MOCK_CHECK_OR_CREATE_OTP_RESPONSE, MOCK_CREATE_OR_UPDATE_USER_RESPONSE, MOCK_CREATE_TAX_REFUND_MEMBER_RESPONSE, MOCK_GET_CC_INFO_RESPONSE, MOCK_GET_CITIES_RESPONSE, MOCK_GET_COUNTRIES_RESPONSE, MOCK_GET_PERSONAL_DETAILS_RESPONSE, MOCK_GET_STREETS_RESPONSE, MOCK_GET_TAX_REFUND_INFO_RESPONSE, MOCK_GET_ZIP_CODE_RESPONSE, MOCK_UPDATE_CC_INFO_RESPONSE, MOCK_UPDATE_CONTACT_DETAILS_RESPONSE, MOCK_UPDATE_POLICY_RESPONSE, MOCK_UPDATE_ZIP_CODE_RESPONSE } from "src/utils/mockResponses";
import { CheckOrCreateOtpResponse, CreateOrUpdateUserRequest, CreateOrUpdateUserResponse, CreateTaxRefundMemberRequest, CreateTaxRefundMemberResponse, CustomerCreditCardResponse, DropDown, GetCountriesResponse, GetTaxRefundInfoRequest, PersonalDetails, StreetsResponse, UpdateCCInfoResponse, UpdateContactDetailsResponse, UpdatePolicyResponse, UpdateZipCodeResponse, ZipCodeResponse } from "src/utils/types";

// Helper function to check if mock data is enabled
const isMockDataEnabled = () => store.getState().app.mockDataEnabled;

export const fetchCitySuggestions = createAsyncThunk(
  "userStore/fetchCitySuggestions",
  async (body: any) => {
    if (isMockDataEnabled()) {
      return MOCK_GET_CITIES_RESPONSE as DropDown[];
    }
    const data = {
      url: "/qry/address/get-cities",
      body,
    };

    const response = await postAsync(data);

    return response;
  }
);
export const fetchAddressSuggestions = createAsyncThunk(
  "userStore/fetchAddressSuggestions",
  async (body: any) => {
    if (isMockDataEnabled()) {
      return MOCK_GET_STREETS_RESPONSE as StreetsResponse;
    }
    const data = {
      url: "/qry/address/get-streets",
      body,
    };

    const response = await postAsync(data);

    return response;
  }
);
export const fetchZipCode = createAsyncThunk(
  "userStore/fetchZipCode",
  async (body: any) => {
    if (isMockDataEnabled()) {
      return MOCK_GET_ZIP_CODE_RESPONSE as ZipCodeResponse;
    }
    const data = {
      url: "/qry/address/get-zipcode",
      body,
    };

    const response = await postAsync(data);

    return response;
  }
);
//cmd/address/update-zipcode
export const updateZipCode = createAsyncThunk(
  "userStore/updateZipCode",
  async (body: any) => {
    if (isMockDataEnabled()) {
      return MOCK_UPDATE_ZIP_CODE_RESPONSE as UpdateZipCodeResponse;
    }
    const data = {
      url: "/cmd/address/update-zipcode",
      body,
    };

    const response = await postAsync(data);
    return response;
  }
);  
export const getCCInfo = createAsyncThunk(
  "userStore/getCCInfo",
  async (body: any) => {
    if (isMockDataEnabled()) {
      return MOCK_GET_CC_INFO_RESPONSE as CustomerCreditCardResponse;
    }
    const data = {
      url: "/cmd/credit-guard/get-cc-info",
      body,
    };
    const response = await postAsync(data);
    return response;
  }
);
export const updateCCInfo = createAsyncThunk(
  "userStore/updateCCInfo",
  async (body: any) => {
    if (isMockDataEnabled()) {
      return MOCK_UPDATE_CC_INFO_RESPONSE as UpdateCCInfoResponse;
    }
    const data = {
      url: "/cmd/credit-guard/update-cc-info",
      body,
    };
    const response = await postAsync(data);
    return response;
  }
);
export const getPersonalDetails = createAsyncThunk(
  "userStore/getPersonalDetails",
  async (body: any) => {
    if (isMockDataEnabled()) {
      return MOCK_GET_PERSONAL_DETAILS_RESPONSE as PersonalDetails;
    }
    const data = {
      url: "/qry/get-personal-details",
      body,
    };
    const response = await postAsync(data);
    return response;
  }
);
export const updatePersonalDetails = createAsyncThunk(
  "userStore/updatePersonalDetails",
  async (body: any) => {
    if (isMockDataEnabled()) {
      return MOCK_UPDATE_CONTACT_DETAILS_RESPONSE as UpdateContactDetailsResponse;
    }
    const data = {
      url: "/cmd/update-personal-details",
      body,
    };
    const response = await postAsync(data);
    return response;
  }
);
export const checkOrCreateOtp = createAsyncThunk(
  "userStore/checkOrCreateOtp",
  async (body: any) => {
    if (isMockDataEnabled()) {
      return MOCK_CHECK_OR_CREATE_OTP_RESPONSE as CheckOrCreateOtpResponse;
    }
    const data = {
      url: "/cmd/check-or-create-otp",
      body,
    };
    const response = await postAsync(data);
    return response;
  }
);
export const updatePolicy = createAsyncThunk(
  "userStore/updatePolicy",
  async (body: any) => {
    if (isMockDataEnabled()) {
      return MOCK_UPDATE_POLICY_RESPONSE as UpdatePolicyResponse;
    }
    const data = {
      url: "/cmd/update-policy",
      body,
    };
    const response = await postAsync(data);
    return response;
  }
);
export const createOrUpdateUser = createAsyncThunk(
  "userStore/createOrUpdateUser",
  async (body: CreateOrUpdateUserRequest) => {
    if (isMockDataEnabled()) {
      return MOCK_CREATE_OR_UPDATE_USER_RESPONSE as CreateOrUpdateUserResponse;
    }
    const data = {
      url: "/cmd/create-or-update-user",
      body,
    };
    const response = await postAsync(data);
    return response;
  }
);
export const getTaxRefundInfo = createAsyncThunk(
  "userStore/getTaxRefundInfo",
  async (body: GetTaxRefundInfoRequest) => {
    if (isMockDataEnabled()) {
      return MOCK_GET_TAX_REFUND_INFO_RESPONSE;
    }
    const data = {
      url: "/qry/get-tax-refund-info",
      body,
    };
    const response = await postAsync(data);
    return response;
  }
);
export const getCountries = createAsyncThunk(
  "userStore/getCountries",
  async (body: any) => {
    if (isMockDataEnabled()) {
      return MOCK_GET_COUNTRIES_RESPONSE as GetCountriesResponse;
    }
    const data = {
      url: "/qry/address/get-countries",
      body,
    };
    const response = await getAsync(data);
    return response;
  }
);
export const createTaxRefundMember = createAsyncThunk(
  "userStore/createTaxRefundMember",
  async (body: CreateTaxRefundMemberRequest) => {
    if (isMockDataEnabled()) {
      return MOCK_CREATE_TAX_REFUND_MEMBER_RESPONSE as CreateTaxRefundMemberResponse;
    }
    const data = {
      url: "/cmd/create-tax-refund-member",
      body,
    };
    const response = await postAsync(data);
    return response;
  }
);





